export const AnalyticsConfig = {
    server: process.env.NEXT_PUBLIC_DOTCMS_HOST,
    siteAuth: process.env.NEXT_PUBLIC_DOTCMS_ANALYTICS_SITE_KEY ?? '',
    debug: process.env.NEXT_PUBLIC_DOTCMS_ANALYTICS_DEBUG ?? process.env.NODE_ENV !== 'production',
    autoPageView: process.env.NEXT_PUBLIC_DOTCMS_ANALYTICS_AUTO_PAGE_VIEW ?? false,
    impressions: process.env.NEXT_PUBLIC_DOTCMS_ANALYTICS_IMPRESSIONS ?? false,
    clicks: process.env.NEXT_PUBLIC_DOTCMS_ANALYTICS_CLICKS ?? false
};
